/** Normalize the selected target into the API contract for a targeted edit. */
export function buildRefinementPayload(refinement) {
  const selectedText = String(refinement?.selectedText ?? '').trim()
  if (!selectedText) return null

  return {
    selectedText,
    source: refinement.source === 'artifact' ? 'artifact' : 'assistant_response',
    ...(refinement.sourceResponseText ? { sourceResponseText: String(refinement.sourceResponseText) } : {}),
    ...(refinement.artifactId ? { artifactId: String(refinement.artifactId) } : {}),
    ...(refinement.artifactName ? { artifactName: String(refinement.artifactName) } : {}),
    ...(refinement.artifactKind ? { artifactKind: String(refinement.artifactKind) } : {}),
  }
}
